import React from 'react';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { PackageFormNested } from '~/components/performable/PackageForm';
import {
  MlmPackage3dInclude,
  MlmPackageAerialInclude,
  MlmPackageFloorplanInclude,
  MlmPackagePhotoInclude, MlmPackageWalkthroughInclude
} from '~/tenants/mlm/package/common';
import MlmPhotosConfig, { MlmPhotosType } from '~/tenants/mlm/performable/photos/MlmPhotosConfig';
import MlmPhotosAddOns from '~/tenants/mlm/performable/photos/MlmPhotosAddOns';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';

export default function MlmStokedPackageForm() {
  return (
    <>
      <TenantPackageIncludes>
        <MlmPackagePhotoInclude photos={36} />
        <MlmPackageFloorplanInclude />
        <MlmPackageAerialInclude />
        <MlmPackage3dInclude />
        <MlmPackageWalkthroughInclude />
      </TenantPackageIncludes>

      <TenantPerformableAddOns persona={PersonaType.CUSTOMER}>
        <PackageFormNested performable={MlmPhotosConfig}>
          <ZodFieldHidden name="type" value={MlmPhotosType.STANDARD} />
          <MlmPhotosAddOns persona={PersonaType.CUSTOMER} />
        </PackageFormNested>
      </TenantPerformableAddOns>
    </>
  );
}
